export enum IncidentNibrsCrimeAgainstType {
    All = 'ALL',
    None = 'NONE',
    Person = 'PERSON',
    Property = 'PROPERTY',
    Society = 'SOCIETY'
}